// import { useEffect, useState, useRef } from "react";
// import { useNavigate, useParams, useLocation } from "react-router-dom";
// import { collection, query, where, getDocs } from "firebase/firestore";
// import { db } from "../../firebase";
// import YouTube from "react-youtube";
// import OneHero from "./oneHero";
// import css from "./hero.module.css";
// import authPic from "../../img/illa.png";
// import arrowLeft from "../../img/arrowInHerpLeft.png";
// import arrowRight from "../../img/arrowInHeroRight.png";
// import arrowImp from "../../img/arrowDownPick.png";
// import transliterate from "../../function/transliterate";

// export default function HeroPage({ windowDimensions }) {
//   const { id } = useParams();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [heroes, setHeroes] = useState([]);
//   const [heroesList, setHeroesList] = useState([]);
//   const [selectedHero, setSelectedHero] = useState(null);
//   const [authorInfo, setAuthorInfo] = useState(null);
//   const [selectedAge, setSelectedAge] = useState("Всі герої");
//   const [ageGroups, setAgeGroups] = useState(["Всі герої"]);
//   const [booksWithHero, setBooksWithHero] = useState([]);

//   const scrollRef = useRef(null);
//   const heroNameRef = useRef(null);

//   // Скрол дозволяємо тільки після ручного вибору героя
//   const shouldScrollAfterSelect = useRef(false);
//   const normalizeText = (value) => {
//     if (value === null || value === undefined) return "";

//     return String(value)
//       .replace(/\u00A0/g, " ")
//       .replace(/\s+/g, " ")
//       .trim()
//       .toLowerCase();
//   };

//   const isSameHeroValue = (value, heroName) => {
//     const normalizedHeroName = normalizeText(heroName);

//     if (!normalizedHeroName) return false;

//     if (Array.isArray(value)) {
//       return value.some((item) => normalizeText(item) === normalizedHeroName);
//     }

//     return normalizeText(value) === normalizedHeroName;
//   };
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [location]);

//   // useEffect(() => {
//   //   const fetchBooksWithHero = async () => {
//   //     if (!selectedHero?.name) return;

//   //     try {
//   //       const productsRef = collection(db, "product");
//   //       const querySnapshot = await getDocs(productsRef);

//   //       const matchingBooks = querySnapshot.docs
//   //         .map((doc) => ({ ...doc.data(), uid: doc.id }))
//   //         .filter((product) => {
//   //           const label = product.heroLabelText;
//   //           const heroName = selectedHero.name.toLowerCase();

//   //           if (typeof label === "string") {
//   //             return label.toLowerCase().includes(heroName);
//   //           }

//   //           if (Array.isArray(label)) {
//   //             return label.some(
//   //               (item) =>
//   //                 typeof item === "string" &&
//   //                 item.toLowerCase().includes(heroName),
//   //             );
//   //           }

//   //           return false;
//   //         });

//   //       setBooksWithHero(matchingBooks);
//   //     } catch (error) {
//   //       console.error("Помилка пошуку книг з героєм:", error);
//   //     }
//   //   };

//   //   fetchBooksWithHero();
//   // }, [selectedHero?.name]);
//   useEffect(() => {
//     const fetchBooksWithHero = async () => {
//       if (!selectedHero?.name && !selectedHero?.uid && !selectedHero?.id) {
//         setBooksWithHero([]);
//         return;
//       }

//       try {
//         const productsRef = collection(db, "product");
//         const querySnapshot = await getDocs(productsRef);

//         const selectedHeroName = selectedHero?.name;
//         const selectedHeroUid = normalizeText(
//           selectedHero?.uid || selectedHero?.id,
//         );

//         const matchingBooks = querySnapshot.docs
//           .map((doc) => ({
//             id: doc.id,
//             uid: doc.id,
//             ...doc.data(),
//           }))
//           .filter((product) => {
//             const productHeroUid = normalizeText(
//               product.bookHeroUid || product.heroUid || product.heroId,
//             );

//             const matchByUid =
//               selectedHeroUid &&
//               productHeroUid &&
//               productHeroUid === selectedHeroUid;

//             const matchByName =
//               isSameHeroValue(product.bookHero, selectedHeroName) ||
//               isSameHeroValue(product.heroName, selectedHeroName) ||
//               isSameHeroValue(product.heroLabelText, selectedHeroName);

//             return matchByUid || matchByName;
//           });

//         setBooksWithHero(matchingBooks);
//       } catch (error) {
//         console.error("Помилка пошуку книг з героєм:", error);
//         setBooksWithHero([]);
//       }
//     };

//     fetchBooksWithHero();
//   }, [selectedHero?.name, selectedHero?.uid, selectedHero?.id]);

//   useEffect(() => {
//     const fetchHeroes = async () => {
//       try {
//         const heroesRef = collection(db, "hero");
//         const querySnapshot = await getDocs(heroesRef);
//         const heroData = querySnapshot.docs.map((doc) => doc.data());

//         setHeroes(heroData);
//         setHeroesList(heroData);

//         if (heroData.length === 0) return;

//         if (!id) {
//           // Перший герой підтягується автоматично, але без скролу
//           setSelectedHero(heroData[0]);
//         } else {
//           const selected = heroData.find((hero) => hero.uid === id);

//           // Герой з URL теж підтягується без автоматичного скролу
//           setSelectedHero(selected || heroData[0]);
//         }
//       } catch (error) {
//         console.error("Помилка при отриманні героїв:", error);
//       }
//     };

//     fetchHeroes();
//   }, [id]);

//   useEffect(() => {
//     const fetchAgeGroups = async () => {
//       try {
//         const querySnapshot = await getDocs(collection(db, "filters"));
//         const filtersData = querySnapshot.docs.map((doc) => doc.data());

//         const ageFilter = filtersData.find(
//           (filter) => filter.transliter === "yearGroup",
//         );

//         if (ageFilter) {
//           setAgeGroups(["Всі герої", ...ageFilter.list]);
//         }
//       } catch (error) {
//         console.error("Помилка отримання вікових груп:", error);
//       }
//     };

//     fetchAgeGroups();
//   }, []);

//   useEffect(() => {
//     const fetchAuthorInfo = async () => {
//       if (selectedHero?.autor) {
//         try {
//           const authorQuery = query(
//             collection(db, "author"),
//             where("name", "==", selectedHero.autor),
//           );

//           const querySnapshot = await getDocs(authorQuery);

//           if (!querySnapshot.empty) {
//             setAuthorInfo(querySnapshot.docs[0].data());
//           }
//         } catch (error) {
//           console.error("Помилка отримання даних автора:", error);
//         }
//       }
//     };

//     fetchAuthorInfo();
//   }, [selectedHero]);

//   const scrollToSelectedHero = () => {
//     requestAnimationFrame(() => {
//       if (heroNameRef.current) {
//         const top =
//           heroNameRef.current.getBoundingClientRect().top +
//           window.pageYOffset -
//           260;

//         window.scrollTo({
//           top,
//           behavior: "smooth",
//         });
//       }
//     });
//   };

//   const handleHeroSelect = (hero) => {
//     if (!hero) return;

//     // Якщо користувач клікнув по вже вибраному герою,
//     // selectedHero не зміниться, тому скролимо вручну
//     if (selectedHero?.uid === hero.uid) {
//       scrollToSelectedHero();
//       return;
//     }

//     shouldScrollAfterSelect.current = true;
//     setSelectedHero(hero);
//   };

//   useEffect(() => {
//     if (!selectedHero) return;

//     // Якщо герой вибрався автоматично при першому завантаженні — не скролимо
//     if (!shouldScrollAfterSelect.current) return;

//     scrollToSelectedHero();

//     shouldScrollAfterSelect.current = false;
//   }, [selectedHero]);

//   const handleAgeChange = (event) => {
//     const selectedValue = event.target.value;
//     setSelectedAge(selectedValue);

//     if (selectedValue === "Всі герої") {
//       setHeroesList(heroes);
//     } else {
//       const filteredHeroes = heroes.filter((hero) => {
//         if (!hero.yearGroup) return false;

//         if (typeof hero.yearGroup === "string") {
//           return hero.yearGroup === selectedValue;
//         }

//         if (Array.isArray(hero.yearGroup)) {
//           return hero.yearGroup.includes(selectedValue);
//         }

//         return false;
//       });

//       setHeroesList(filteredHeroes);
//     }
//   };

//   const scrollLeft = () =>
//     scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });

//   const scrollRight = () =>
//     scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });

//   const goToBook = () => {
//     if (selectedHero?.book) {
//       navigate(`/product/${transliterate(selectedHero.book)}`);
//     }
//   };
//   const getYoutubeVideoId = (value) => {
//     if (!value) return "";

//     const videoValue = String(value).trim();

//     if (videoValue.includes("youtube.com/watch?v=")) {
//       return videoValue.split("v=")[1]?.split("&")[0] || "";
//     }

//     if (videoValue.includes("youtu.be/")) {
//       return videoValue.split("youtu.be/")[1]?.split("?")[0] || "";
//     }

//     if (videoValue.includes("youtube.com/embed/")) {
//       return videoValue.split("embed/")[1]?.split("?")[0] || "";
//     }

//     if (videoValue.includes("youtube.com/shorts/")) {
//       return videoValue.split("shorts/")[1]?.split("?")[0] || "";
//     }

//     return videoValue;
//   };

//   return (
//     <div>
//       <div className={css.allBooksWrap}>
//         <div className={css.allHero}>
//           <p className={css.yourPerfectHero}>
//             Ваші улюблені герої книг
//             <br />
//             <span className={css.yourPerfectHeroSpan}>
//               переймай найкраще від улюблених персонажів
//             </span>
//           </p>

//           <div className={css.ageWrap}>
//             <p className={css.children}>Дитині</p>

//             <div className={css.chousBooksSelect}>
//               <select
//                 className={css.customSelect}
//                 value={selectedAge}
//                 onChange={handleAgeChange}
//               >
//                 {ageGroups.map((value, index) => (
//                   <option key={index} className={css.customOpin} value={value}>
//                     {value}
//                   </option>
//                 ))}
//               </select>

//               <img
//                 src={arrowImp}
//                 className={css.customArrowSelect}
//                 alt="Arrow"
//               />
//             </div>
//           </div>
//         </div>

//         <div className={css.autorListSmal}>
//           <img
//             src={arrowLeft}
//             onClick={scrollLeft}
//             className={css.arrowLeftSt}
//             alt="Scroll Left"
//           />

//           <div className={css.autorListSmalNew} ref={scrollRef}>
//             {heroesList.map((hero, index) => (
//               <OneHero
//                 key={index}
//                 heroesList={heroesList}
//                 handleHeroClick={handleHeroSelect}
//                 hero={hero}
//                 selectedHero={selectedHero}
//               />
//             ))}
//           </div>

//           <img
//             src={arrowRight}
//             onClick={scrollRight}
//             className={css.arrowRightSt}
//             alt="Scroll Right"
//           />
//         </div>
//       </div>

//       {selectedHero && (
//         <div className={css.wrapHeroBigFoto}>
//           <div className={css.wrapHeroBigFotoTwo}>
//             <div className={css.imgAutorWrapBig}>
//               <img
//                 src={selectedHero.foto || authPic}
//                 className={css.imgAutorBig}
//                 alt="Hero"
//               />
//             </div>

//             <div className={css.descHeroOP}>
//               <h1 className={css.heroName} ref={heroNameRef}>
//                 {selectedHero.name}
//               </h1>

//               <p className={css.dotP}>{selectedHero.descOne}</p>
//               <p className={css.dotP}>{selectedHero.descSecond}</p>

//               {booksWithHero.length > 1 ? (
//                 <div className={css.heroBooksList}>
//                   <p className={css.whatBook}>Герой зустрічається у книгах:</p>

//                   <div className={css.wrapAllBooksHero}>
//                     {booksWithHero.map((book) => (
//                       <div key={book.uid} className={css.bookLinkWrap}>
//                         <p className={css.bookTitle}>{book.bookName}</p>

//                         <button
//                           className={css.buttonHeroo}
//                           onClick={() =>
//                             navigate(`/product/${transliterate(book.bookName)}`)
//                           }
//                         >
//                           Перейти до книги
//                         </button>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ) : (
//                 <>
//                   <p className={css.whatBook}>
//                     Герой книги {selectedHero.autor}&nbsp; {selectedHero.book}
//                   </p>

//                   <button onClick={goToBook} className={css.buttonHeroo}>
//                     Перейти до книги
//                   </button>
//                 </>
//               )}
//             </div>
//           </div>

//           <div className={css.yellowFitchWrap}>
//             <p className={css.yellowFitchWrapP}>{selectedHero.smallDesc}</p>
//             <div className={css.hvist}></div>
//           </div>

//           <div className={css.historiCreateBlock}>
//             <p className={css.hictoryP}>{selectedHero.history}</p>
//           </div>

//           <div className={css.blockInturv}>
//             <div className={css.blockInturvSmall}>
//               {/* <h3 className={css.inturvH3}>Інтерв’ю з героєм</h3> */}
//               <p className={css.inturvP}>{selectedHero.internOne}</p>
//               <p className={css.inturvP}>{selectedHero.internSecond}</p>
//             </div>
//           </div>
//         </div>
//       )}

//       <div className={css.videoBlockWrap}>
//         <div className={css.videoBlockWrapSmall}>
//           <h4 className={css.seeBook}>Огляд книги</h4>

//           <div className={css.video}>
//             {selectedHero?.video && (
//               <YouTube
//                 key={selectedHero.video}
//                 videoId={getYoutubeVideoId(selectedHero.video)}
//                 className={css.youtubeWrap}
//                 iframeClassName={css.youtubeFrame}
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import YouTube from "react-youtube";
import OneHero from "./oneHero";
import css from "./hero.module.css";
import authPic from "../../img/illa.png";
import arrowLeft from "../../img/arrowInHerpLeft.png";
import arrowRight from "../../img/arrowInHeroRight.png";
import arrowImp from "../../img/arrowDownPick.png";
import transliterate from "../../function/transliterate";

export default function HeroPage({ windowDimensions }) {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [heroes, setHeroes] = useState([]);
  const [heroesList, setHeroesList] = useState([]);
  const [selectedHero, setSelectedHero] = useState(null);
  const [authorInfo, setAuthorInfo] = useState(null);
  const [selectedAge, setSelectedAge] = useState("Всі герої");
  const [ageGroups, setAgeGroups] = useState(["Всі герої"]);
  const [booksWithHero, setBooksWithHero] = useState([]);

  const scrollRef = useRef(null);
  const heroNameRef = useRef(null);

  const shouldScrollAfterSelect = useRef(false);
  const normalizeText = (value) => {
    if (value === null || value === undefined) return "";

    return String(value)
      .replace(/\u00A0/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  };

  const isSameHeroValue = (value, heroName) => {
    const normalizedHeroName = normalizeText(heroName);

    if (!normalizedHeroName) return false;

    if (Array.isArray(value)) {
      return value.some((item) => normalizeText(item) === normalizedHeroName);
    }

    return normalizeText(value) === normalizedHeroName;
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // useEffect(() => {
  //   const fetchBooksWithHero = async () => {
  //     if (!selectedHero?.name) return;

  //     try {
  //       const productsRef = collection(db, "product");
  //       const querySnapshot = await getDocs(productsRef);

  //       const matchingBooks = querySnapshot.docs
  //         .map((doc) => ({ ...doc.data(), uid: doc.id }))
  //         .filter((product) => {
  //           const label = product.heroLabelText;
  //           const heroName = selectedHero.name.toLowerCase();

  //           if (typeof label === "string") {
  //             return label.toLowerCase().includes(heroName);
  //           }

  //           if (Array.isArray(label)) {
  //             return label.some(
  //               (item) =>
  //                 typeof item === "string" &&
  //                 item.toLowerCase().includes(heroName),
  //             );
  //           }

  //           return false;
  //         });

  //       setBooksWithHero(matchingBooks);
  //     } catch (error) {
  //       console.error("Помилка пошуку книг з героєм:", error);
  //     }
  //   };

  //   fetchBooksWithHero();
  // }, [selectedHero?.name]);
  useEffect(() => {
    const fetchBooksWithHero = async () => {
      if (!selectedHero?.name && !selectedHero?.uid && !selectedHero?.id) {
        setBooksWithHero([]);
        return;
      }

      try {
        const productsRef = collection(db, "product");
        const querySnapshot = await getDocs(productsRef);

        const selectedHeroName = selectedHero?.name;
        const selectedHeroUid = normalizeText(
          selectedHero?.uid || selectedHero?.id,
        );

        const matchingBooks = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            uid: doc.id,
            ...doc.data(),
          }))
          .filter((product) => {
            const productHeroUid = normalizeText(
              product.bookHeroUid || product.heroUid || product.heroId,
            );

            const matchByUid =
              selectedHeroUid &&
              productHeroUid &&
              productHeroUid === selectedHeroUid;

            const matchByName =
              isSameHeroValue(product.bookHero, selectedHeroName) ||
              isSameHeroValue(product.heroName, selectedHeroName) ||
              isSameHeroValue(product.heroLabelText, selectedHeroName);

            return matchByUid || matchByName;
          });

        setBooksWithHero(matchingBooks);
      } catch (error) {
        console.error("Помилка пошуку книг з героєм:", error);
        setBooksWithHero([]);
      }
    };

    fetchBooksWithHero();
  }, [selectedHero?.name, selectedHero?.uid, selectedHero?.id]);

  useEffect(() => {
    const fetchHeroes = async () => {
      try {
        const heroesRef = collection(db, "hero");
        const querySnapshot = await getDocs(heroesRef);
        const heroData = querySnapshot.docs.map((doc) => doc.data());

        setHeroes(heroData);
        setHeroesList(heroData);

        if (heroData.length === 0) return;

        if (!id) {
          // Перший герой підтягується автоматично, але без скролу
          setSelectedHero(heroData[0]);
        } else {
          const selected = heroData.find((hero) => hero.uid === id);

          // Герой з URL теж підтягується без автоматичного скролу
          setSelectedHero(selected || heroData[0]);
        }
      } catch (error) {
        console.error("Помилка при отриманні героїв:", error);
      }
    };

    fetchHeroes();
  }, [id]);

  useEffect(() => {
    const fetchAgeGroups = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "filters"));
        const filtersData = querySnapshot.docs.map((doc) => doc.data());

        const ageFilter = filtersData.find(
          (filter) => filter.transliter === "yearGroup",
        );

        if (ageFilter) {
          setAgeGroups(["Всі герої", ...ageFilter.list]);
        }
      } catch (error) {
        console.error("Помилка отримання вікових груп:", error);
      }
    };

    fetchAgeGroups();
  }, []);

  useEffect(() => {
    const fetchAuthorInfo = async () => {
      if (selectedHero?.autor) {
        try {
          const authorQuery = query(
            collection(db, "author"),
            where("name", "==", selectedHero.autor),
          );

          const querySnapshot = await getDocs(authorQuery);

          if (!querySnapshot.empty) {
            setAuthorInfo(querySnapshot.docs[0].data());
          }
        } catch (error) {
          console.error("Помилка отримання даних автора:", error);
        }
      }
    };

    fetchAuthorInfo();
  }, [selectedHero]);

  const scrollToSelectedHero = () => {
    requestAnimationFrame(() => {
      if (heroNameRef.current) {
        const top =
          heroNameRef.current.getBoundingClientRect().top +
          window.pageYOffset -
          260;

        window.scrollTo({
          top,
          behavior: "smooth",
        });
      }
    });
  };

  const handleHeroSelect = (hero) => {
    if (!hero) return;

    // Якщо користувач клікнув по вже вибраному герою,
    // selectedHero не зміниться, тому скролимо вручну
    if (selectedHero?.uid === hero.uid) {
      scrollToSelectedHero();
      return;
    }

    shouldScrollAfterSelect.current = true;
    setSelectedHero(hero);
  };

  useEffect(() => {
    if (!selectedHero) return;

    // Якщо герой вибрався автоматично при першому завантаженні — не скролимо
    if (!shouldScrollAfterSelect.current) return;

    scrollToSelectedHero();

    shouldScrollAfterSelect.current = false;
  }, [selectedHero]);

  const handleAgeChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedAge(selectedValue);

    if (selectedValue === "Всі герої") {
      setHeroesList(heroes);
    } else {
      const filteredHeroes = heroes.filter((hero) => {
        if (!hero.yearGroup) return false;

        if (typeof hero.yearGroup === "string") {
          return hero.yearGroup === selectedValue;
        }

        if (Array.isArray(hero.yearGroup)) {
          return hero.yearGroup.includes(selectedValue);
        }

        return false;
      });

      setHeroesList(filteredHeroes);
    }
  };

  const scrollLeft = () =>
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });

  const scrollRight = () =>
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });

  const goToBook = () => {
    if (selectedHero?.book) {
      navigate(`/product/${transliterate(selectedHero.book)}`);
    }
  };
  const getYoutubeVideoId = (value) => {
    if (!value) return "";

    const videoValue = String(value).trim();

    if (videoValue.includes("youtube.com/watch?v=")) {
      return videoValue.split("v=")[1]?.split("&")[0] || "";
    }

    if (videoValue.includes("youtu.be/")) {
      return videoValue.split("youtu.be/")[1]?.split("?")[0] || "";
    }

    if (videoValue.includes("youtube.com/embed/")) {
      return videoValue.split("embed/")[1]?.split("?")[0] || "";
    }

    if (videoValue.includes("youtube.com/shorts/")) {
      return videoValue.split("shorts/")[1]?.split("?")[0] || "";
    }

    return videoValue;
  };

  return (
    <div>
      <div className={css.allBooksWrap}>
        <div className={css.allHero}>
          <p className={css.yourPerfectHero}>
            Ваші улюблені герої книг
            <br />
            <span className={css.yourPerfectHeroSpan}>
              переймай найкраще від улюблених персонажів
            </span>
          </p>

          <div className={css.ageWrap}>
            <p className={css.children}>Дитині</p>

            <div className={css.chousBooksSelect}>
              <select
                className={css.customSelect}
                value={selectedAge}
                onChange={handleAgeChange}
              >
                {ageGroups.map((value, index) => (
                  <option key={index} className={css.customOpin} value={value}>
                    {value}
                  </option>
                ))}
              </select>

              <img
                src={arrowImp}
                className={css.customArrowSelect}
                alt="Arrow"
              />
            </div>
          </div>
        </div>

        <div className={css.autorListSmal}>
          <img
            src={arrowLeft}
            onClick={scrollLeft}
            className={css.arrowLeftSt}
            alt="Scroll Left"
          />

          <div className={css.autorListSmalNew} ref={scrollRef}>
            {heroesList.map((hero, index) => (
              <OneHero
                key={index}
                heroesList={heroesList}
                handleHeroClick={handleHeroSelect}
                hero={hero}
                selectedHero={selectedHero}
              />
            ))}
          </div>

          <img
            src={arrowRight}
            onClick={scrollRight}
            className={css.arrowRightSt}
            alt="Scroll Right"
          />
        </div>
      </div>

      {selectedHero && (
        <div className={css.wrapHeroBigFoto}>
          <div className={css.wrapHeroBigFotoTwo}>
            <div className={css.imgAutorWrapBig}>
              <img
                src={selectedHero.foto || authPic}
                className={css.imgAutorBig}
                alt="Hero"
              />
            </div>

            <div className={css.descHeroOP}>
              <h1 className={css.heroName} ref={heroNameRef}>
                {selectedHero.name}
              </h1>

              <p className={css.dotP}>{selectedHero.descOne}</p>
              <p className={css.dotP}>{selectedHero.descSecond}</p>

              {booksWithHero.length > 1 ? (
                <div className={css.heroBooksList}>
                  <p className={css.whatBook}>Герой зустрічається у книгах:</p>

                  <div className={css.wrapAllBooksHero}>
                    {booksWithHero.map((book) => (
                      <div key={book.uid} className={css.bookLinkWrap}>
                        <p className={css.bookTitle}>{book.bookName}</p>

                        <button
                          className={css.buttonHeroo}
                          onClick={() =>
                            navigate(`/product/${transliterate(book.bookName)}`)
                          }
                        >
                          Перейти до книги
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <>
                  <p className={css.whatBook}>
                    Герой книги {selectedHero.autor}&nbsp; {selectedHero.book}
                  </p>

                  <button onClick={goToBook} className={css.buttonHeroo}>
                    Перейти до книги
                  </button>
                </>
              )}
            </div>
          </div>

          <div className={css.yellowFitchWrap}>
            <p className={css.yellowFitchWrapP}>{selectedHero.smallDesc}</p>
            <div className={css.hvist}></div>
          </div>

          <div className={css.historiCreateBlock}>
            <p className={css.hictoryP}>{selectedHero.history}</p>
          </div>

          <div className={css.blockInturv}>
            <div className={css.blockInturvSmall}>
              {/* <h3 className={css.inturvH3}>Інтерв’ю з героєм</h3> */}
              <p className={css.inturvP}>{selectedHero.internOne}</p>
              <p className={css.inturvP}>{selectedHero.internSecond}</p>
            </div>
          </div>
        </div>
      )}

      <div className={css.videoBlockWrap}>
        <div className={css.videoBlockWrapSmall}>
          <h4 className={css.seeBook}>Огляд книги</h4>

          <div className={css.video}>
            {selectedHero?.video && (
              <YouTube
                key={selectedHero.video}
                videoId={getYoutubeVideoId(selectedHero.video)}
                className={css.youtubeWrap}
                iframeClassName={css.youtubeFrame}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
